
import { Vue, Options } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getWatermark } from '@/app/infrastructures/misc/Utils';

@Options({
  name: "Watermark"
})
export default class WatermarkPage extends Vue {
  get svgBg() {
    return getWatermark();
  }
}
